<template>
  <div class="figure__wrapper" :class="{'figure__wrapper-details': isDetails}">
    <svg :width="defaultSvgParams.width * figureSvgScale"
         :height="defaultSvgParams.height * figureSvgScale"
         :viewBox="`0 0 ${defaultSvgParams.width * figureSvgScale}
         ${defaultSvgParams.height * figureSvgScale}`"
         ref="figure"
         @mouseover="detectCursor()"
         @mouseout="unDetectCursor()"
         :style="{transform: `scale(${zoom})`}">
      <line
        x1="0"
        :y1="changeLeftSideHeightUp"
        :x2="defaultSvgParams.width"
        :y2="changeLeftSideHeightUp"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> //ruler horizontal top 1
      <line
        x1="0"
        :y1="changeRightSideHeightUp"
        :x2="defaultSvgParams.width"
        :y2="changeRightSideHeightUp"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> //ruler horizontal top 2
      <line
        x1="0"
        :y1="changeLeftSideHeightDown"
        :x2="defaultSvgParams.width"
        :y2="changeLeftSideHeightDown"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> // ruler horizontal bottom 1
      <line
        x1="0"
        :y1="changeRightSideHeightDown"
        :x2="defaultSvgParams.width"
        :y2="changeRightSideHeightDown"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> // ruler horizontal bottom 2
      <line
        :x1="changeWidthLeft"
        y1="0"
        :x2="changeWidthLeft"
        :y2="defaultSvgParams.height"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> // ruler vertical 2
      <line
        :x1="changeWidthRight"
        y1="0"
        :x2="changeWidthRight"
        :y2="defaultSvgParams.height"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> // ruler vertical 3
      <path :d="arrowHeight" fill="none" :stroke="isDetails ? arrowsColor : '#1FAFED'"
        stroke-width="2" style="stroke-linecap: round;" v-if="!isNav"></path> // arrow height
      <path :d="arrowWidth" fill="none" :stroke="isDetails ? arrowsColor : '#C6B4FB'"
        stroke-width="2" style="stroke-linecap: round;" v-if="!isNav"></path> // arrow width
      <path :d="arrowBiasTop" fill="none" :stroke="isDetails ? arrowsColor : '#F5BB4A'"
        stroke-width="2" style="stroke-linecap: round;" v-if="!isNav"></path> // arrow bias top
      <path :d="arrowBiasBottom" fill="none" :stroke="isDetails ? arrowsColor : '#FF6928'"
        stroke-width="2" style="stroke-linecap: round;" v-if="!isNav"></path> // arrow bias bottom
      <path :d="arrowDirection" fill="none" :stroke="arrowStrokeColor"
        :stroke-width="strokeWidth" style="stroke-linecap: round;"
        v-if="!isDetails"></path> // arrow Direction
      <defs v-if="isPlate">
        <clipPath id="figureMask">
          <path :d="reverseTrapezoidMask" fill="none" :stroke="figureStrokeColor"
           :stroke-width="strokeWidth"
            style="stroke-linecap: round;"></path> // reverse trapezoid mask
        </clipPath>
      </defs>
      <text :x="changeWidthLeft - 10" :y="(changeLeftSideHeightUp + changeRightSideHeightUp) / 2"
        fill="#333333" text-anchor="middle"
        :transform="`rotate(-90 ${changeWidthLeft - 10}
        ${(changeLeftSideHeightUp + changeRightSideHeightUp) / 2})`"
        v-if="isDetails"
        >{{ slopeParams.bias1 }} m</text>
      <text :x="changeWidthLeft - 10"
        :y="(changeLeftSideHeightDown + changeRightSideHeightDown) / 2"
        fill="#333333" text-anchor="middle"
        :transform="`rotate(-90 ${changeWidthLeft - 10}
        ${(changeLeftSideHeightDown + changeRightSideHeightDown) / 2})`"
        v-if="isDetails"
        >{{ slopeParams.bias2 }} m</text>
      <text :x="changeWidthRight + 20"
            :y="(this.defaultSvgParams.height * this.figureSvgScale) / 2"
            fill="#333333"
            text-anchor="middle"
            v-if="isDetails"
            :transform="`rotate(-90 ${changeWidthRight + 20}
            ${(this.defaultSvgParams.height * this.figureSvgScale) / 2})`">
              {{ slopeParams.height }} m
      </text>
      <text :x="`${(this.defaultSvgParams.width * this.figureSvgScale) / 2}`"
            :y="changeLeftSideHeightDown + 20" fill="#333333"
            text-anchor="middle" v-if="isDetails">{{ slopeParams.width }} m</text>
      <g v-if="isDetails" clip-path="url(#figureMask)"> <!--clip-path="url(#figureMask)"-->
        <g> <!--:transform="`translate(0 ${marginBottom})`"-->
          <g v-for="i in rowsCount" :key="i" class="row__overlay">
            <rect :x="changeWidthRight - (plateWidth * (i))"
                  :y="i % 2 === 0 ? rowStartY - (plateHeight / 2) : rowStartY"
                  :width="plateWidth - 1"
                  :height="i % 2 === 0 ? rowHeight + plateHeight : rowHeight"
                  fill="#F6F6F6" stroke="#999999"
                  stroke-width="1"
                  style="shape-rendering: crispEdges;"
                  @mouseover="showRowInfo(i)"
                  @mouseout="hideRowInfo()"
                  ></rect>
            <line :x1="changeWidthRight - (plateWidth * (i))"
                  :y1="i % 2 === 0 ? rowStartY + (plateHeight * n) + (plateHeight / 2)
                  : rowStartY + (plateHeight * n)"
                  :x2="changeWidthRight - (plateWidth * (i)) + plateWidth - 1"
                  :y2="i % 2 === 0 ? rowStartY + (plateHeight * n) + (plateHeight / 2)
                  : rowStartY + (plateHeight * n)"
                  stroke="#999999"
                  stroke-width="1"
                  style="shape-rendering: crispEdges;"
                  v-for="n in i % 2 === 0 ? (itemPerRow) : (itemPerRow - 1)" :key="n"></line>
                  (plateHeight * n + (plateHeight / 2)) + shift
          </g>
        </g>
      </g>
      <path :d="reverseTrapezoid" fill="none" :stroke="figureStrokeColor"
      :stroke-width="strokeWidth"
      style="stroke-linecap: round;"></path> // reverse trapezoid
      <!--<line
        :x1="changeWidthRight"
        :y1="changeRightSideHeightUp"
        :x2="changeWidthRight"
        :y2="changeLeftSideHeightUp"
        stroke="red" stroke-width="4" style="stroke-linecap: round;"/> // bias top
      <line
        :x1="changeWidthRight"
        :y1="changeRightSideHeightDown"
        :x2="changeWidthRight"
        :y2="changeLeftSideHeightDown"
        stroke="blue" stroke-width="4" style="stroke-linecap: round;"/> // bias bottom
      <line
        :x1="changeWidthLeft"
        :y1="changeRightSideHeightUp"
        :x2="changeWidthLeft"
        :y2="changeRightSideHeightDown"
        stroke="green" stroke-width="4" style="stroke-linecap: round;" /> // left side
      <line
        :x1="changeWidthRight"
        :y1="changeRightSideHeightUp"
        :x2="changeWidthRight"
        :y2="changeRightSideHeightDown"
        stroke="yellow" stroke-width="4" style="stroke-linecap: round;" /> // right side
      <line
        :x1="changeWidthLeft"
        :y1="changeRightSideHeightUp"
        :x2="changeWidthRight"
        :y2="changeLeftSideHeightUp"
        stroke="brown" stroke-width="4" style="stroke-linecap: round;" /> // top side
      <line
        :x1="changeWidthLeft"
        :y1="changeRightSideHeightDown"
        :x2="changeWidthRight"
        :y2="changeLeftSideHeightDown"
        stroke="#333333" stroke-width="4" style="stroke-linecap: round;"/> // bottom side-->
    </svg>
      <!--<div class="data" v-if="!isNav">
        <h1>coef: {{ scale }}</h1>
        <h1>scaleH: {{ scaleH }}</h1>
        <h1>scaleW: {{ scaleW }}</h1>
      </div>-->
      <MyPopover
        :rowId = "rowId"
        :layersCount = "slopeFromState.slopeLayersCount"
        :plateHeight = "slopeFromState.materialSize.height"
        :plateWidth = "slopeFromState.materialSize.width"
        :windowWidth = "windowWidth"
        :materialAngle = "materialAngle"
        :fixtureCalculationThickness = "fixtureCalculationThickness"
        :backEndRowsCount="backEndRowsCount"
        :masonryType="masonryType"
        :hKr="hKr"
        :qKr="qKr"
        :y1="y1"
        :y2="y2"
        :mouseLeft = "mouseLeft"
        :mouseTop = "mouseTop"
      />
  </div>
</template>

<script>

import MyPopover from '../MyPopover.vue';

export default {
  props: {
    isNav: Boolean,
    defaultSvgParams: Object,
    isDetails: Boolean,
    isPlate: Boolean,
    navId: Number,
    zoom: Number,
    materialAngle: Number,
    fixtureCalculationThickness: Number,
    backEndRowsCount: Number,
    masonryType: String,
    hKr: Number,
    qKr: Number,
    y1: Number,
    y2: Number,
  },
  data() {
    return {
      rowId: 0,
      mouseTop: null,
      mouseLeft: null,
      windowWidth: null,
    };
  },
  watch: {
  },
  components: {
    MyPopover,
  },
  methods: {
    showRowInfo(i) {
      this.rowId = i;
    },
    hideRowInfo() {
      this.rowId = 0;
    },
    getCursorPosition(e) {
      this.mouseTop = e.clientY;
      this.mouseLeft = e.clientX;
    },
    detectCursor() {
      document.addEventListener('mousemove', this.getCursorPosition);
      this.windowWidth = window.innerWidth;
    },
    unDetectCursor() {
      document.removeEventListener('mousemove', this.getCursorPosition);
    },
  },
  computed: {
    shift() {
      return 480 - this.rowHeight;
    },
    slopeFromState() {
      return (!this.isNav && !this.isDetails) || (this.isDetails && this.isPlate)
        ? this.$store.getters.getSlope(this.slopeId)
        : this.$store.getters.getSlope(this.navId);
    },
    slopeId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    allSlopes() {
      return this.$store.getters.allSlopes;
    },
    slopeParams() {
      return this.slopeFromState.slopeParams[0];
    },
    halfPlate() {
      return (this.columnsCount % 2 === 0)
        ? 0 : (((this.slopeFromState.materialSize.height / 1000) / 2) * this.scale);
    },
    rowsCount() {
      return Math.ceil((this.slopeFromState.slopeParams[0].width * 1000)
                       / this.slopeFromState.materialSize.width);
    },
    itemPerRow() {
      return (Math.ceil(480 / ((this.slopeFromState.materialSize.height / 1000) * this.scale))) + 1;
    },
    plateHeight() {
      return (this.slopeFromState.materialSize.height / 1000) * this.scale;
    },
    plateWidth() {
      return (this.slopeFromState.materialSize.width / 1000) * this.scale;
    },
    rowHeight() {
      return this.itemPerRow * this.plateHeight;
    },
    rowStartY() {
      return this.changeLeftSideHeightDown - this.rowHeight;
    },
    indentationToHeight() {
      return ((480 - ((this.slopeFromState.slopeParams[0].height
                   + this.slopeFromState.slopeParams[0].bias1
                   + this.slopeFromState.slopeParams[0].bias2) * this.scale)) / 2)
        - (this.plateHeight / 2);
    },
    cathet() {
      return ((this.slopeFromState.slopeParams[0].bias2
               * (this.slopeFromState.materialSize.width / 1000))
      / this.slopeFromState.slopeParams[0].width) * this.scale;
    },
    marginBottom() {
      // return ((((this.indentationToHeight + this.cathet)
      // % ((this.slopeFromState.materialSize.height / 1000) * this.scale)) - this.halfPlate)
      //          + ((this.slopeFromState.materialSize.height / 1000) * this.scale));
      return this.indentationToHeight * -1;
    },
    arrowStrokeColor() {
      return this.isNav ? '#C8C8C8' : '#999999';
    },
    figureStrokeColor() {
      return this.isNav || this.isDetails ? '#959595' : '#333333';
    },
    strokeWidth() {
      return this.isNav || this.isDetails ? 2 : 4;
    },
    arrowsColor() {
      return '#999999';
    },
    figureSvgScale() {
      return this.isNav ? this.defaultSvgParams.navScale : 1;
    },
    arrowDirectionSize() {
      return this.isNav ? 5 : 10;
    },
    arrowHeight() {
      return `M${this.changeWidthRight + 30},${this.changeRightSideHeightUp}
      L${this.changeWidthRight + 30},${this.changeRightSideHeightDown}
      M${this.changeWidthRight + 35},${this.changeRightSideHeightUp + 6}
      L${this.changeWidthRight + 30},${this.changeRightSideHeightUp}
      M${this.changeWidthRight + 25},${this.changeRightSideHeightUp + 6}
      L${this.changeWidthRight + 30},${this.changeRightSideHeightUp}
      M${this.changeWidthRight + 35},${this.changeRightSideHeightDown - 6}
      L${this.changeWidthRight + 30},${this.changeRightSideHeightDown}
      M${this.changeWidthRight + 25},${this.changeRightSideHeightDown - 6}
      L${this.changeWidthRight + 30},${this.changeRightSideHeightDown}`;
    },
    arrowWidth() {
      return `M${this.changeWidthLeft},${this.changeLeftSideHeightDown + 30}
      L${this.changeWidthRight},${this.changeLeftSideHeightDown + 30}
      M${this.changeWidthLeft + 6},${this.changeLeftSideHeightDown + 25}
      L${this.changeWidthLeft},${this.changeLeftSideHeightDown + 30}
      M${this.changeWidthLeft + 6},${this.changeLeftSideHeightDown + 35}
      L${this.changeWidthLeft},${this.changeLeftSideHeightDown + 30}
      M${this.changeWidthRight - 6},${this.changeLeftSideHeightDown + 25}
      L${this.changeWidthRight},${this.changeLeftSideHeightDown + 30}
      M${this.changeWidthRight - 6},${this.changeLeftSideHeightDown + 35}
      L${this.changeWidthRight},${this.changeLeftSideHeightDown + 30}`;
    },
    arrowBiasTop() {
      return `M${this.changeWidthLeft - 33},${this.changeRightSideHeightUp}
      L${this.changeWidthLeft - 33},${this.changeLeftSideHeightUp}
      M${this.changeWidthLeft - 28},${this.changeLeftSideHeightUp + 6}
      L${this.changeWidthLeft - 33},${this.changeLeftSideHeightUp}
      M${this.changeWidthLeft - 38},${this.changeLeftSideHeightUp + 6}
      L${this.changeWidthLeft - 33},${this.changeLeftSideHeightUp}
      M${this.changeWidthLeft - 28},${this.changeRightSideHeightUp - 6}
      L${this.changeWidthLeft - 33},${this.changeRightSideHeightUp}
      M${this.changeWidthLeft - 38},${this.changeRightSideHeightUp - 6}
      L${this.changeWidthLeft - 33},${this.changeRightSideHeightUp}`;
    },
    arrowBiasBottom() {
      return `M${this.changeWidthLeft - 33},${this.changeRightSideHeightDown}
      L${this.changeWidthLeft - 33},${this.changeLeftSideHeightDown}
      M${this.changeWidthLeft - 28},${this.changeLeftSideHeightDown - 6}
      L${this.changeWidthLeft - 33},${this.changeLeftSideHeightDown}
      M${this.changeWidthLeft - 38},${this.changeLeftSideHeightDown - 6}
      L${this.changeWidthLeft - 33},${this.changeLeftSideHeightDown}
      M${this.changeWidthLeft - 28},${this.changeRightSideHeightDown + 6}
      L${this.changeWidthLeft - 33},${this.changeRightSideHeightDown}
      M${this.changeWidthLeft - 38},${this.changeRightSideHeightDown + 6}
      L${this.changeWidthLeft - 33},${this.changeRightSideHeightDown}`;
    },
    arrowDirection() {
      return `M${this.arrowDirectionStartX},${this.arrowDirectionY}
      L${this.arrowDirectionEndX},${this.arrowDirectionY}
      M${this.arrowDirectionEndX - this.arrowDirectionSize},${this.arrowDirectionY - this.arrowDirectionSize}
      L${this.arrowDirectionEndX},${this.arrowDirectionY}
      M${this.arrowDirectionEndX - this.arrowDirectionSize},${this.arrowDirectionY + this.arrowDirectionSize}
      L${this.arrowDirectionEndX},${this.arrowDirectionY}`;
    },
    reverseTrapezoid() {
      return `M ${this.changeWidthRight},${this.changeRightSideHeightUp}
      L${this.changeWidthRight},${this.changeLeftSideHeightUp}
      M${this.changeWidthRight},${this.changeLeftSideHeightUp}
      L${this.changeWidthLeft},${this.changeRightSideHeightUp}
      M${this.changeWidthLeft},${this.changeRightSideHeightUp}
      L${this.changeWidthLeft},${this.changeRightSideHeightDown}
      M${this.changeWidthLeft},${this.changeRightSideHeightDown}
      L${this.changeWidthRight},${this.changeLeftSideHeightDown}
      M${this.changeWidthRight},${this.changeLeftSideHeightDown}
      L${this.changeWidthRight},${this.changeRightSideHeightDown}
      M${this.changeWidthRight},${this.changeRightSideHeightDown}
      L${this.changeWidthRight},${this.changeRightSideHeightUp}`;
    },
    reverseTrapezoidMask() {
      return `M ${this.changeWidthRight},${this.changeRightSideHeightUp}
      L${this.changeWidthRight},${this.changeLeftSideHeightUp}
      L${this.changeWidthLeft},${this.changeRightSideHeightUp}
      L${this.changeWidthLeft},${this.changeRightSideHeightDown}
      L${this.changeWidthRight},${this.changeLeftSideHeightDown}
      L${this.changeWidthRight},${this.changeRightSideHeightDown}
      L${this.changeWidthRight},${this.changeRightSideHeightUp} Z`;
    },
    scaleH() { // коэффициент высоты
      return (((this.defaultSvgParams.baseHeight * this.figureSvgScale)) * 100)
      / (this.slopeParams.height
         + this.slopeParams.bias1 + this.slopeParams.bias2);
    },
    scaleW() { // коэффициент ширины
      return ((this.defaultSvgParams.baseWidth * this.figureSvgScale) * 100)
      / this.slopeParams.width;
    },
    scale() { // применяемый коэффициент в зависимости от того какой из коэффициентов больше
      return (this.scaleW > this.scaleH) ? this.scaleH : this.scaleW;
    },
    scaledBiasTop() { // размер верхнего смещения с применённым коэффициентом
      return (this.slopeParams.bias1 * this.scale);
    },
    scaledBiasBottom() { // размер нижнего смещения с применённым коэффициентом
      return (this.slopeParams.bias2 * this.scale);
    },
    biasTop() { // половина верхнего смещения
      return (this.scaledBiasTop / 2);
    },
    biasBottom() { // половина нижнего смещения
      return (this.scaledBiasBottom / 2);
    },
    biasDifference() { // разница смещений
      return (this.biasTop - this.biasBottom);
    },
    changeWidthLeft() { // изменяем ширину влево
      return (((this.defaultSvgParams.width * this.figureSvgScale) / 2)
              - ((this.slopeParams.width * this.scale) / 2));
    },
    changeWidthRight() { // изменяем ширину вправо
      return (((this.defaultSvgParams.width * this.figureSvgScale) / 2)
              + ((this.slopeParams.width * this.scale) / 2));
    },
    changeHeightUp() { // изменяем высоту вверх
      return (((this.defaultSvgParams.height * this.figureSvgScale) / 2)
              - ((this.slopeParams.height * this.scale) / 2));
    },
    changeHeightDown() { // изменяем высоту вниз
      return (((this.defaultSvgParams.height * this.figureSvgScale) / 2)
              + ((this.slopeParams.height * this.scale) / 2));
    },
    changeRightSideHeightUp() { // изменяем правую сторону вверх фигуры с учетом смещений
      return (this.changeHeightUp + this.biasDifference);
    },
    changeRightSideHeightDown() { // изменяем правую сторону вниз фигуры с учетом смещений
      return (this.changeHeightDown + this.biasDifference);
    },
    changeLeftSideHeightUp() { // изменяем левую сторону вверх фигуры с учетом смещений
      return ((this.changeHeightUp - this.scaledBiasTop) + this.biasDifference);
    },
    changeLeftSideHeightDown() { // изменяем левую сторону вниз фигуры с учетом смещений
      return ((this.changeHeightDown + this.scaledBiasBottom) + this.biasDifference);
    },
    arrowDirectionStartX() { // изменяем ширину направляющей стрелки влево
      return (((this.defaultSvgParams.width * this.figureSvgScale) / 2)
              - (((this.slopeParams.width / 2) * this.scale) / 2));
    },
    arrowDirectionEndX() { // изменяем ширину напрвляющей стрелки вправо
      return (((this.defaultSvgParams.width * this.figureSvgScale) / 2)
              + (((this.slopeParams.width / 2) * this.scale) / 2));
    },
    arrowDirectionY() { // изменяем положение напрвляющей стрелки по высоте
      return ((this.changeRightSideHeightDown + this.changeRightSideHeightUp) / 2);
    },
  },
  mounted() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
</style>
